module.exports = __webpack_public_path__ + "static/media/default-top-post-blue.2460487d.jpg";